import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ElasticSearch from '../../homepage/header-banner/ElasticSearch';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBox from '../../container/Box/Components/CardBox';
// import { MuiGrid } from '@mui/material';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function ClustercloudelasticsearchVN() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Elastic Search Engine")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}

                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Tối ưu truy vấn với khả năng sharding và replica trên Kubernetes</p>",
                            `<p class='typo-14'>Elasticsearch sử dụng nền tảng Lucene để tăng tốc độ truy vấn nhờ cơ chế sharding.</p>
                            <p class='typo-14'>Trong trường hợp container (POD) gặp sự cố, hệ thống vẫn duy trì hoạt động ổn định nhờ vào các bản sao (replica).</p>
                            <p class='typo-14'>Giải pháp đã được ứng dụng rộng rãi trong nhiều hệ thống, tích lũy hơn 15 năm kinh nghiệm vận hành thực tế. </p>`)}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Vận hành volume Persistent hiệu suất cao, tối ưu I/O</p>",
                            `<p class='typo-14'>Dữ liệu được lưu trữ trên ổ SSD và phân phối qua 3 container replica cho từng dịch vụ.</p>
                            <p class='typo-14'>Khi một node phần cứng trong Kubernetes bị lỗi, replica POD sẽ tự động tiếp quản, đảm bảo dịch vụ luôn hoạt động liên tục, không bị gián đoạn.</p>`
                        )}
                        </MuiGrid>
                        {/*
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "컨테이너(POD)하드웨어의 자유로운 구성으로 최적의 클러스터 구현",
                            "컨테이너(POD)에 할당되는 서버자원은 고객의 요구에 맞게 할당할 수 있으며, ElasticSearch 클러스터 시스템을 자유롭게 구성할 수 있습니다."
                            )}
                        </MuiGrid>
                        */}
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Di chuyển container (POD) tự động khi có sự cố phần cứng, duy trì hoạt động liên tục</p>",
                            `<p class='typo-14'>Mỗi dịch vụ Elasticsearch chạy đồng thời 3 replica POD.</p>
                            <p class='typo-14'>Các replica này được phân bổ trên nhiều node worker trong hệ thống Kubernetes, giúp dịch vụ không bị gián đoạn khi một node gặp lỗi phần cứng.</p>`
                        )}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Tự động mở rộng container và cân bằng tải hiệu quả</p>",
                            `<p class='typo-14'>Số lượng container (POD) được tự động điều chỉnh dựa trên nhu cầu sử dụng CPU, bộ nhớ hoặc hành vi người dùng.</p>
                            <p class='typo-14'>Nhờ khả năng phân phối và mở rộng linh hoạt, dịch vụ luôn đạt hiệu suất cao mà không cần đầu tư thêm tài nguyên vật lý.</p>
                            <p class='typo-14'>Cụm cluster thông minh hỗ trợ mở rộng quy mô mượt mà và tối ưu hóa hiệu suất hệ thống.</p>`
                        )}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12}>{Imagecloudcompute("https://www.hanbiro.com/cloud/library/cluster-cloud-elastic-search/elasticsearch_cluster.svg")}</MuiGrid>
                        <DividerComponent />

                        {/* <ElasticSearch /> */}
                        {/* <CloudconsultCp /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            {/* <Footer /> */}
            <FooterVn />
        </Sysfont>

    );

};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClustercloudelasticsearchVN;